import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useAppContext } from "../context/appContext";
import idApi from "../service/IdApi";
import { throttle } from "lodash";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Mixpanel } from "../utils/Mixpanel";

const loadScript = (src) =>
    new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve()
        const script = document.createElement('script')
        script.src = src
        script.onload = () => resolve()
        script.onerror = (err) => reject(err)
        document.body.appendChild(script)
    })

const GrantFacebookFriendAccess = ({ showGrantFacebookFriendAccess, hideGrantFacebookFriendAccess }) => {
    const { displayAlert } = useAppContext();
    const [isVisible, setIsVisible] = useState(false);
    const [isConnectWithFacebookProcessing, setIsConnectWithFacebookProcessing] = useState(false);
    const navigate = useNavigate();

    const facebookFriendAccessGrantedMutation = useMutation(() => {
        try {
            var body = {};
            body.fbFriendsAllowed = true;
            return idApi.patch("auth/user/facebook-friend-access", body);
        } catch (error) {
            throw error;
        }
    });

    useEffect(() => {
        if (showGrantFacebookFriendAccess) {
            setIsVisible(true);
        }
        else {
            setIsVisible(false);
        }
    }, [showGrantFacebookFriendAccess]);

    useEffect(() => {
        const facebookSrc = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v21.0&appId=' + process.env.REACT_APP_FACEBOOK_APP_ID + '&autoLogAppEvents=1';
        loadScript(facebookSrc);
    }, []);

    const connectWithFacebook = throttle(() => {
        setIsConnectWithFacebookProcessing(true);
        window.FB.login(function (response) {
            if (response.authResponse) {
                facebookFriendAccessGrantedMutation.mutate({}, {
                    onError: (error, variables, context) => {
                        console.error('Failed to fetch token:', error);
                        var mixpanelMessage = "Error updating facebook friend access: " + error;
                        Mixpanel.track("UI ID - Javascript error", {
                            'Javascript Error': mixpanelMessage
                        });
                        displayAlert("error", "Unexpected Error", "Unexpected error. Please try again later");
                        setIsConnectWithFacebookProcessing(false);
                        hideGrantFacebookFriendAccess();
                    },
                    onSuccess: () => {
                        displayAlert("success", "Success", "Facebook friend access granted successfully");
                        navigate('/account/add-facebook-friends')
                    },
                });
            } else {
                displayAlert("error", "Error", "Facebook friend access denied");
                setIsConnectWithFacebookProcessing(false);
                hideGrantFacebookFriendAccess();
            }
        }, {
            scope: 'user_friends',
            auth_type: 'rerequest'
        });
    }, 500, { trailing: false });

    return (
        <div>
            <Dialog
                visible={isVisible}
                style={{ width: '425px' }}
                breakpoints={{ '641px': '95vw' }}
                header="Connect Facebook Friends"
                modal
                onHide={hideGrantFacebookFriendAccess}
                className="p-fluid p-input-filled"
            >
                <div className="flex flex-column">
                    <div>
                        Wallist helps you find your next local pro or new favorite restaurant by showing you recommendations from your Facebook friends - the people you already know and trust!
                    </div>
                    <div className="mt-3">
                        You will be able to pick and choose which friends to connect with on Wallist.
                    </div>
                    <div className="mt-3">
                        Wallist cannot access your entire friend list. Only friends that have also granted Wallist access will be available.
                    </div>
                </div>
                <div className="flex mt-3 w-full justify-content-center">
                    <div>
                        <Button icon="pi pi-thumbs-up" label="Grant Permission on Facebook" onClick={connectWithFacebook} loading={isConnectWithFacebookProcessing} />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default GrantFacebookFriendAccess;
